"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTitleRenderer = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("../text");
var _react2 = require("@emotion/react");
const defaultTitleRenderer = _ref => {
  let {
    titleText
  } = _ref;
  return (0, _react2.jsx)(_text.H2, null, titleText);
};
exports.defaultTitleRenderer = defaultTitleRenderer;